import { createContext, useContext, useMemo, useState } from "react";

// // ── Role definitions
// export const ROLES = {
//   SUPER_ADMIN: "super_admin",
//   OPS_MANAGER: "ops_manager",
//   SUPPORT_STAFF: "support_staff",
//   FINANCE_TEAM: "finance_team",
// };

// // ── Module keys
// export const MODULES = {
//   DASHBOARD: "group-dashboard",
//   CONSULTATION: "group-consultation",
//   OPERATIONS: "group-operations",
//   MASTER: "group-master",
//   CMS: "group-cms",
//   DELIVERY: "group-delivery",
//   RESTAURANT: "group-restaurant",
//   ROLES: "group-roles",
//   UTILITIES: "utilities",
//   SUPPORT: "support",
//   AUTH: "authentication",
// };

// // ── Permission map per role
// export const ROLE_PERMISSIONS = {
//   [ROLES.SUPER_ADMIN]: Object.values(MODULES),

//   [ROLES.OPS_MANAGER]: [
//     MODULES.DASHBOARD,
//     MODULES.CONSULTATION,
//     MODULES.OPERATIONS,
//     MODULES.DELIVERY,
//     MODULES.RESTAURANT,
//     MODULES.SUPPORT,
//   ],

//   [ROLES.SUPPORT_STAFF]: [
//     MODULES.DASHBOARD,
//     MODULES.CONSULTATION,
//     MODULES.OPERATIONS,
//     MODULES.SUPPORT,
//   ],

//   [ROLES.FINANCE_TEAM]: [
//     MODULES.DASHBOARD,
//     MODULES.OPERATIONS,
//     MODULES.SUPPORT,
//   ],
// };


const AuthContext = createContext(null);

const TOKEN_KEY = "token";
const USER_KEY = "user";

export function AuthProvider({ children }) {
  const [token, setToken] = useState(
    localStorage.getItem(TOKEN_KEY) || null
  );

  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(USER_KEY)) || null;
    } catch {
      return null;
    }
  });

  const loggeedUser = (users) => {
    setUser(users);
    localStorage.setItem(USER_KEY, users);
    return { success: true };
  };

  const login = (accessToken) => {
    setToken(accessToken);
    localStorage.setItem(TOKEN_KEY, accessToken);
    return { success: true };
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  };

  const hasPermission = (moduleKey) => {
    if (!user) return false;

    return ROLE_PERMISSIONS[user.role]?.includes(moduleKey) ?? false;
  };

  const value = useMemo(
    () => ({
      token,
      user,
      login,
      logout,
      hasPermission,
      setUser,
      setToken,
      loggeedUser,
    }),
    [token, user]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

// ── Hook
export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }

  return context;
};